import { validateEmail } from '@reveni-io/reveni-ui'

export const isFormValid = ({ orderNumber, identifier, isGiftReturn, giftRecipient, skipIdentifierValidation }) => {
  if (!orderNumber?.trim()) return false

  const shouldSkipIdentifier = isGiftReturn && skipIdentifierValidation
  if (!shouldSkipIdentifier && !identifier?.trim()) return false

  if (isGiftReturn) {
    if (!giftRecipient?.first_name?.trim()) return false
    if (!giftRecipient.last_name?.trim()) return false
    if (!validateEmail(giftRecipient.email)) return false
  }

  return true
}
